module.exports = function() {
  return new Worker(__webpack_public_path__ + "1e0e8018841f21b6affd.worker.js");
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/worker-loader/dist/cjs.js!./src/app/models/site-distances-calculator-worker.js
// module id = 606
// module chunks = 1